import { module } from 'angular';
import mailViewerComponent from './mail-viewer.component';
import mailViewerRecipientsComponent from './mail-viewer-recipients/mail-viewer-recipients.component';
import mailViewerAttachmentComponent from './mail-viewer-attachment/mail-viewer-attachment.component';
import unquoteStringFilter from './unquote-string.filter';

// eslint-disable-next-line angular/function-type
export default module('app.mailViewer', [])
	.component('mailViewer', mailViewerComponent)
	.component('mailViewerRecipients', mailViewerRecipientsComponent)
	.component('mailViewerAttachment', mailViewerAttachmentComponent)
	.filter('unquoteString', () => unquoteStringFilter)
	.name;
